<script setup lang="ts">
import {MapPinIcon, CalendarDaysIcon} from "@heroicons/vue/24/outline";
const {collectionUri, pageUri} = useI18nCollection();

const config = useRuntimeConfig().public;

const page = await queryCollection(collectionUri('home')).path(pageUri('home/intro')).first();
const imgUri = computed<string>(() => (page.meta?.image || '').replace('/assets', ''));
const ctaList = computed(() => page.meta?.cta || []);
</script>

<template>
  <div class="container-md spacer-section">
    <div class="tablet:flex items-center justify-center bg-light block-round  flex-row-reverse gap-x-12">
      <div class="text-brand-dark p-4 tablet:p-0">
        <div class="text-lg tablet:text-2xl mb-8">
          <p class="mb-4 inline-flex items-center">
            <CalendarDaysIcon class="size-8 tablet:size-12 me-2 opacity-50 text-brand-dark" />
            {{ config.opening_hours.human }}
          </p>
          <p>
            <a
                :href="config.contact.address.url"
                class="inline-flex items-center"
            >
              <MapPinIcon class="size-8 tablet:size-12 me-2  opacity-50 text-brand-dark" />
              {{ config.contact.address.human }}
            </a>
          </p>
        </div>
        <ContentRenderer :value="page" class="mb-8" />

        <div class="flex flex-wrap gap-4 mb-8 tablet:mb-0">
          <ButtonCta v-for="cta in ctaList" :key="cta.label" :cta="cta" class="border-dotted border-b text-secondary" />
        </div>
      </div>
      <picture
              class="basis-1/2 w-full relative block aspect-[0.9] rounded-2xl overflow-hidden"
      >
        <media-source
                :uri="imgUri"
                :expose-only="false"
                :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
                sizes="100vw"
                :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
                format="webp"
                as="source"
        />
        <media-source
                :uri="imgUri"
                :expose-only="false"
                :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
                sizes="100vw"
                format="jpg"
                as="img"
                class="w-full h-full object-cover relative z-1"
        />
      </picture>
    </div>
  </div>
</template>